export const CRTMSG = 'Error While Creating...';
export const UPTMSG = 'Error While Updating...';
export const DELMSG = 'Error While Deleting...';